import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import {
  DashboardAlignmentsEnum,
  DashboardComponentTypesEnum,
} from '../reports.enum';

export const DEFAULT_TEXT_ALIGNMENT = DashboardAlignmentsEnum.left;

export const TEXT_SCHEMA = Object.freeze({
  TYPE: '',
  FG_COLOR: null, // string
  LABEL: '',
  ALIGNMENT: DEFAULT_TEXT_ALIGNMENT,
  URL: null, // string
  GROUP: 0,
});
const RECORD = generateSchema(TEXT_SCHEMA);
const KEYS: any = generateKeys(TEXT_SCHEMA);

export class Text extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return DashboardComponentTypesEnum.text;
  }

  get fgColor(): string {
    return this.get(KEYS.FG_COLOR);
  }

  get label(): string {
    return this.get(KEYS.LABEL);
  }

  get alignment(): string {
    return this.get(KEYS.ALIGNMENT);
  }

  get url(): string {
    return this.get(KEYS.URL);
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }
}
